import RecentActivityPanel from './RecentActivityPanel.component';

export default RecentActivityPanel;
